<!--
KeyDate component
@author rb304x
-->
<template>
  <div class="keyDateDiv keyDateBox" v-if="keyDate.category">

    <img alt="" :src="getImage(keyDate.category.name)" class="keyDateBg" />
    <span>
      <div class="keyDateHeaderN">{{ title }}</div>
    </span><br>

    <p class="keyDateBodyN" v-if="keyDate.datesConfirmed == 'true'">{{ keyDateDate }}</p>
    <p class="keyDateBodyN" v-if="keyDate.datesConfirmed == 'false'">TBC</p>
    <span class="keyDateCategoryList"><p class="keyDateCategory">{{ getCategory }}</p></span>

  </div>
</template>

<script setup>
//Composables
import {ref, computed} from 'vue'
import { useStringUtil } from '@/composables/StringMethods.js'
const { displayKeyDateInfo } = useStringUtil()

//Props
const props = defineProps({
  title: String,
  startDate: Number,
  endDate: Number,
  keyDate: Object
})

//Data
let evinfo = displayKeyDateInfo(props.startDate, props.endDate)
const keyDateDate =  ref(evinfo.date)

//Computed
const getCategory = computed(() => {
  if (props.keyDate.category.name) {
      return props.keyDate.category.name
  } else {
    return ''
  }
})

function getImage (category) {
  var images = require.context('@/assets/keydates/', false, /\.svg$/)
  return images('./' + category + '.svg')
}

function checkMultiDate () {
  // var start = new Date(startDate)
  // var end = new Date(endDate)
  // if (start == end) return false
  // return true
  return false // until we get keyDate end dates
}
</script>

<style scoped>
.keyDateCategoryList {
  margin-left:48px;
  overflow:hidden;
  padding-top:8px;
}
.keyDateCategory {
  display:inline-block;
  font-size:12px;
  color:#951272;
  padding-left:20px;
  overflow:hidden;
  margin-bottom:16px;
}
.keyDateLocIcon {
  margin-right:6px;
  margin-top:2px;
  margin-left:50px;
  float: left;
}
.keyDateLoc {
  overflow:hidden;
  margin-bottom:0px;
  margin-left:0px;
  margin-right:12px;
  font-size:12px;
  font-weight:400;
}
.keyDateSocial {
  display:inline-block;
  padding-left:48px;
  padding-bottom:20px;
}

.keyDateSocial img {
  margin-right:8px;
  margin-left:0px;
}

.keyDateChev {
  position:absolute;
  top:45%;
  right:16px;
}

.notificationIcon {
  z-index:999;
  position:absolute;
  color:#ffffff;
}

.keyDateBox {
border: 1px solid #e4e4e4;
box-sizing: border-box;
border-radius: 24px;
}

.keyDateDiv {
  margin-bottom:12px;
  padding:16px;
  padding-bottom:0px;
  padding-top:8px;
  position:relative;
}

.keyDateBg {
  position:absolute;
  left:24px;
  top:24px;
  z-index:1;
}

.keyDateBodyN {
  font-size: 18px;
  color: #4F5961;
  padding-left:68px;
  padding-right:8%;
  margin-top:0px;
  margin-bottom:0px;
  display:block;
}

.keyDateHeaderN {
  font-style: normal;
  display:inline-block;
  padding-left:68px;
  font-weight: bold;
  font-size: 18px;
  line-height:21px;
  margin-top:16px;
  margin-bottom:0px;
  color: #003865;
}
</style>
